import Vue from 'vue'
import AddToWishlist from 'FrontComponents/vue/AddToWishlist/Index.vue'
import { store } from '../../components/front/vue/store/store'

/**
 * Then you can do stuff like this:
 *
 * route('bids.store')
 */

if (document.querySelector('#wishlist')) {
    Vue.mixin({
        methods: {
            route: route,
        },
    })

    new Vue({
        el: '#wishlist',
        store,
        components: {
            AddToWishlist,
        },
    })
}
